import { contains, Path, pathOr, toLower } from 'ramda';
import { isNilOrEmpty } from './ramda_utils';

export function useFilter<T>(filter: string, filterProperty: Path, list: T[]): T[] {
  if (isNilOrEmpty(filter)) return list;
  return list.filter((p) =>
    contains(toLower(filter), toLower(pathOr<string>('', filterProperty, p))),
  );
}
